import { z } from 'zod';

/** Route path for subscription priority (múltiplas inscrições). */
export const subscriptionPriorityFullPath = '/users/$userId/subscription/order-priority' as const;

export const subscriptionPriorityParamsSchema = z.object({
  userId: z.string().transform(Number),
});

export type SubscriptionPriorityParams = z.infer<typeof subscriptionPriorityParamsSchema>;
